var _mask, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftEllipseBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1156,
    height: 318,
    viewBox: "0 0 1156 318",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask9",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1156,
    height: 318
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1156,
    height: 318,
    fill: "url(#paint0_linear)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.273 734.545C322.243 734.545 453.545 603.243 453.545 441.273C453.545 279.303 322.243 148 160.273 148C-1.69736 148 -133 279.303 -133 441.273C-133 603.243 -1.69736 734.545 160.273 734.545ZM160.416 563.279C227.719 563.279 282.279 508.719 282.279 441.416C282.279 374.112 227.719 319.552 160.416 319.552C93.1123 319.552 38.5522 374.112 38.5522 441.416C38.5522 508.719 93.1123 563.279 160.416 563.279Z",
    fill: "#ECEBFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-8.72501 303.55C169.815 303.55 314.55 158.815 314.55 -19.725C314.55 -198.265 169.815 -343 -8.72501 -343C-187.265 -343 -332 -198.265 -332 -19.725C-332 158.815 -187.265 303.55 -8.72501 303.55ZM-8.5672 114.759C65.6213 114.759 125.763 54.6173 125.763 -19.5712C125.763 -93.7598 65.6213 -153.901 -8.5672 -153.901C-82.7558 -153.901 -142.897 -93.7598 -142.897 -19.5712C-142.897 54.6173 -82.7558 114.759 -8.5672 114.759Z",
    fill: "#03B8EC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -0.00000246723,
    y1: 172.25,
    x2: 1156,
    y2: 172.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#262262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3990"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftEllipseBg);
export default __webpack_public_path__ + "static/media/leftEllipseBg.40a80befdd342c8f6d826ae6962404fa.svg";
export { ForwardRef as ReactComponent };